/** @format **/

import { generateScreen } from "./generator";

const jobScreens = (i18n) => ({
  industry: {
    type: "question.industry",
    params: {
      list: true,
      scrollShadow: true,
      text: () => i18n.t("job:industry.title"),
      placeholder: () => i18n.t("job:industry.search"),
      dispatchKey: "updateJob",
      propertyName: "industry",
      currentAnswer: (store) => store.state.job.industry,
      selectorConfig: {
        type: "search",
      },
      answerDataMapping: (selectedOption) => {
        return {
          id: selectedOption.value,
          name: selectedOption.label,
        };
      },
      answers: (store) => {
        const { industries = [] } = store.state.partner || {};
        return industries.map((id) => {
          return {
            value: id,
            label: i18n.t(`job:industry.industries.${id}`),
          };
        });
      },
    },
  },
  industryInput: {
    type: "open-question.industry-input",
    params: {
      title: () => i18n.t("job:otherIndustry.title"),
      placeholder: (store) => i18n.t("job:otherIndustry.placeholder"),
      description: (store) => i18n.t("job:otherIndustry.description"),
      currentAnswer: (store) => store.state.job.otherIndustry,
      dispatchKey: "updateJob",
      propertyName: "otherIndustry",
      buttonTrackingLabel: "industry-submit-button",
      inputName: "industry",
      conditions: [
        {
          property: "job.isOtherIndustry",
          value: true,
        },
      ],
    },
  },
  occupation: {
    type: "question.occupation",
    params: {
      list: true,
      scrollShadow: true,
      text: () => i18n.t("job:occupation.title"),
      placeholder: () => i18n.t("job:occupation.search"),
      description: () => i18n.t("job:occupation.description"),
      dispatchKey: "updateJob",
      propertyName: "occupation",
      currentAnswer: (store) => store.state.job.occupation,
      selectorConfig: {
        type: "search",
      },
      answerDataMapping: (selectedOption) => {
        return {
          id: selectedOption.value,
          name: selectedOption.label,
        };
      },
      answers: (store) => {
        const { occupations = [] } = store.state.partner || {};
        return occupations.map((id) => ({
          value: id,
          label: i18n.t(`job:occupation.occupations.${id}`),
        }));
      },
    },
  },
  companyName: {
    type: "company-autocomplete",
  },
  companyPhone: {
    type: "phone-number.company",
    params: {
      title: () => i18n.t("job:phoneNumber.title"),
      placeholder: (store) => i18n.t("job:phoneNumber.placeholder"),
      description: (store) => i18n.t("job:otherIndustry.example"),
      dispatchKey: "updateJob",
      propertyName: "phone",
      conditions: [
        {
          property: "job.phone",
          isSet: false,
        },
      ],
    },
  },
});

export const getJobScreens = generateScreen.bind(null, jobScreens);



// WEBPACK FOOTER //
// ./src/partners/config/screens/job.js